import React, { useState } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Text,
  Menu,
  MenuButton,
  MenuList,
  Icon,
  Button,
  Spinner,
  Center,
  VStack,
  MenuItem,
  useToast,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  HStack,
  Checkbox,
  ModalFooter,
  IconButton,
  Portal,
} from "@chakra-ui/react";
import { IoIosArrowDown, IoMdCheckmark, IoMdClose } from "react-icons/io";
import { FiInfo } from "react-icons/fi";
import axios from "../../utils/axios";
import Cookies from "js-cookie";
import DeleteModal from "../../components/modal/DeleteModal";
import CustomInput from "../../components/input/CustomInput";
import PasswordInput from "../../components/input/PasswordInput";
import CustomTextArea from "../../components/input/CustomTextArea";
import { useNavigate } from "react-router-dom";

const ListTable = ({ data, headerData, isLoading, setTrigger }) => {
  // console.log("AdminList Table -->", data);
  const [isDisable, setIsDisable] = useState(false);
  const [driverId, setDriverId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [lastName, setLastName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [registerNumber, setRegisterNumber] = useState("");
  const [address, setAddress] = useState("");
  const [password, setPassword] = useState("");
  const [carPlateNumber, setCarPlateNumber] = useState("");
  const [carModel, setCarModel] = useState("");
  const [editPass, setEditPass] = useState(false);
  const toast = useToast();
  const id = "toast";
  const token = Cookies.get("accessToken");
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const clearData = () => {
    setLastName("");
    setFirstName("");
    setPhoneNo("");
    setPassword("");
    setAddress("");
    setCarModel("");
    setCarPlateNumber("");
    setRegisterNumber("");
  };

  const editHandler = (value) => {
    // console.log(value);
    setDriverId(value._id);
    setLastName(value.lastName);
    setFirstName(value.firstName);
    setPhoneNo(value.phoneNo);
    setAddress(value.address);
    setRegisterNumber(value.registerNumber);
    setCarModel(value.carModel);
    setCarPlateNumber(value.carPlateNumber);
  };

  const deleteHandler = () => {
    if (driverId) {
      setIsDisable(true);
      axios
        .delete("/api/driver/", {
          data: {
            driverId: driverId,
          },
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        })
        .then((result) => {
          // console.log(result.data);
          if (!toast.isActive(id)) {
            toast({
              id,
              duration: 2000,
              position: "top",
              status: "success",
              description: "Амжилттай!",
            });
          }
          setDriverId("");
          setShowModal(false);
          setTrigger(true);
          setIsDisable(false);
        })
        .catch((err) => {
          // console.log(err);
          setIsDisable(false);
          if (!toast.isActive(id)) {
            toast({
              id,
              duration: 2000,
              position: "top",
              status: "error",
              description: err.response.data.error
                ? err.response.data.error
                : "Алдаа гарлаа!",
            });
          }
        });
    }
  };

  const submitHandler = () => {
    if (driverId) {
      setIsDisable(true);
      axios
        .put(
          "/api/driver/",
          {
            driverId: driverId,
            firstName: firstName,
            lastName: lastName,
            address: address,
            phoneNo: phoneNo,
            registerNumber: registerNumber,
            carPlateNumber: carPlateNumber,
            carModel: carModel,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((result) => {
          // console.log(result.data);
          if (result.data.success) {
            if (!toast.isActive(id)) {
              toast({
                id,
                duration: 2000,
                position: "top",
                status: "success",
                description: "Амжилттай!",
              });
            }
            setDriverId("");
            onClose();
            setTrigger(true);
          }
          setIsDisable(false);
        })
        .catch((err) => {
          // console.log(err);
          if (!toast.isActive(id)) {
            toast({
              id,
              duration: 2000,
              position: "top",
              status: "error",
              description: err.response.data.error
                ? err.response.data.error
                : "Алдаа гарлаа!",
            });
          }
          setIsDisable(false);
        });
    }
  };

  const passwordHandler = () => {
    if (driverId && password) {
      setIsDisable(true);
      axios
        .put(
          "/api/driver/password",
          {
            driverId: driverId,
            newPassword: password,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((result) => {
          // console.log(result.data);
          if (result.data.success) {
            if (!toast.isActive(id)) {
              toast({
                id,
                duration: 2000,
                position: "top",
                status: "success",
                description: "Амжилттай!",
              });
            }
            setDriverId("");
            setPassword("");
            setEditPass(false);
            onClose();
          }
          setIsDisable(false);
        })
        .catch((err) => {
          // console.log(err);
          if (!toast.isActive(id)) {
            toast({
              id,
              duration: 2000,
              position: "top",
              status: "error",
              description: err.response.data.error
                ? err.response.data.error
                : "Алдаа гарлаа!",
            });
          }
          setIsDisable(false);
        });
    }
  };
  return (
    <VStack w={"full"}>
      <TableContainer w={"full"} pos={"relative"}>
        <Table border={"1px"} borderColor={"#ECECEC"} className="primaryColor">
          {headerData ? (
            <Thead bg={"#f9f9f9"}>
              <Tr>
                {headerData.map((e, i) => (
                  <Th
                    key={i}
                    borderRight={"1px"}
                    borderRightColor={"#ECECEC"}
                    fontSize={13}
                    fontWeight={"medium"}
                    textTransform={"initial"}
                  >
                    {e}
                  </Th>
                ))}
              </Tr>
            </Thead>
          ) : null}
          {data.length > 0
            ? data.map((e, i) => (
                <Tbody key={i}>
                  <Tr w={"full"}>
                    <Td
                      w={"6"}
                      borderRight={"1px"}
                      borderRightColor={"#ECECEC"}
                      align={"center"}
                      justify={"flex-start"}
                    >
                      <Text fontSize={14} fontWeight={"normal"} color={"#000"}>
                        {i + 1}
                      </Text>
                    </Td>
                    {/* ------------ firstName, lastName ------------ */}
                    <Td
                      borderRight={"1px"}
                      borderRightColor={"#ECECEC"}
                      justify={"flex-start"}
                    >
                      <Text
                        fontSize={14}
                        fontWeight={"normal"}
                        color={"#000"}
                        textTransform={"capitalize"}
                      >
                        {e.firstName && e.lastName
                          ? e.lastName + ", " + e.firstName
                          : "-"}
                      </Text>
                    </Td>
                    {/* ------------ No ------------ */}
                    <Td
                      borderRight={"1px"}
                      borderRightColor={"#ECECEC"}
                      justify={"flex-start"}
                    >
                      <Text fontSize={14} fontWeight={"normal"} color={"#000"}>
                        {e.registerNumber ? e.registerNumber : "-"}
                      </Text>
                    </Td>
                    {/* ------------ phoneNo ------------ */}
                    <Td
                      flexWrap={"wrap"}
                      whiteSpace={"normal"}
                      borderRight={"1px"}
                      borderRightColor={"#ECECEC"}
                      justify={"flex-start"}
                    >
                      <Text fontSize={14} fontWeight={"normal"} color={"#000"}>
                        {e.phoneNo ? e.phoneNo : "-"}
                      </Text>
                    </Td>
                    {/* ------------ address ------------ */}
                    <Td
                      flexWrap={"wrap"}
                      whiteSpace={"normal"}
                      borderRight={"1px"}
                      borderRightColor={"#ECECEC"}
                      justify={"flex-start"}
                    >
                      <Text fontSize={14} fontWeight={"normal"} color={"#000"}>
                        {e.address ? e.address : "-"}
                      </Text>
                    </Td>
                    {/* ------------ carModel ------------ */}
                    <Td
                      flexWrap={"wrap"}
                      whiteSpace={"normal"}
                      borderRight={"1px"}
                      borderRightColor={"#ECECEC"}
                      justify={"flex-start"}
                    >
                      <Text fontSize={14} fontWeight={"normal"} color={"#000"}>
                        {e.carModel ? e.carModel : "-"}
                      </Text>
                    </Td>
                    {/* ------------ carModel ------------ */}
                    <Td
                      flexWrap={"wrap"}
                      whiteSpace={"normal"}
                      borderRight={"1px"}
                      borderRightColor={"#ECECEC"}
                      justify={"flex-start"}
                    >
                      <Text fontSize={14} fontWeight={"normal"} color={"#000"}>
                        {e.carPlateNumber ? e.carPlateNumber : "-"}
                      </Text>
                    </Td>
                    <Td w={"20"} py={"2"}>
                      <Menu gutter={1} autoSelect={false} placement={"bottom"}>
                        <MenuButton
                          as={Button}
                          bg={"#fff"}
                          borderRadius="none"
                          borderWidth="1px"
                          color={"#000"}
                          fontWeight={"normal"}
                          fontSize={13}
                          h={"8"}
                          alignItems={"center"}
                          justifyContent={"center"}
                          rightIcon={<Icon as={IoIosArrowDown} />}
                          _focus={{ outline: "none", bg: "#fff" }}
                          _expanded={{
                            bg: "#fff",
                          }}
                          _hover={{
                            bg: "#fff",
                          }}
                          _active={{
                            bg: "#fff",
                          }}
                        >
                          Үйлдэл
                        </MenuButton>

                        <Portal>
                          <MenuList
                            minW="24"
                            w={"max-content"}
                            p={"0"}
                            rounded={"none"}
                            shadow={"md"}
                          >
                            <MenuItem
                              color={"#000"}
                              fontWeight={"normal"}
                              fontSize={13}
                              onClick={() => {
                                navigate("/driver/detail", { state: e });
                              }}
                            >
                              Дэлгэрэнгүй
                            </MenuItem>
                            <MenuItem
                              color={"#000"}
                              fontWeight={"normal"}
                              fontSize={13}
                              onClick={() => {
                                editHandler(e);
                                onOpen();
                                // navigate("/driver/add", { state: e });
                              }}
                            >
                              Засварлах
                            </MenuItem>
                            <MenuItem
                              color={"#000"}
                              fontWeight={"normal"}
                              fontSize={13}
                              onClick={() =>
                                navigate("/driver/area", { state: e })
                              }
                            >
                              Орчим
                            </MenuItem>
                            <MenuItem
                              color={"#ff0000"}
                              fontWeight={"normal"}
                              fontSize={13}
                              onClick={() => {
                                setDriverId(e._id);
                                setShowModal(true);
                              }}
                            >
                              Устгах
                            </MenuItem>
                          </MenuList>
                        </Portal>
                      </Menu>
                    </Td>
                  </Tr>
                </Tbody>
              ))
            : null}
        </Table>
      </TableContainer>
      {isLoading && (
        <Center w={"full"} h={"10"}>
          <Spinner color={"#1CAE81"} />
        </Center>
      )}
      {!isLoading && data.length === 0 && (
        <VStack w={"full"} spacing={1} py={"2"}>
          <Icon as={FiInfo} w={"5"} h={"5"} />
          <Text fontSize={13} color={"#000"} fontWeight={"normal"}>
            Мэдээлэл олдсонгүй
          </Text>
        </VStack>
      )}
      <DeleteModal
        showModal={showModal}
        setShowModal={setShowModal}
        isDisable={isDisable}
        deleteHandler={deleteHandler}
      />

      <Modal
        isCentered
        onClose={onClose}
        isOpen={isOpen}
        closeOnOverlayClick={false}
      >
        <ModalOverlay />
        <ModalContent w={"sm"} rounded={"sm"}>
          <ModalHeader fontSize={17}>Жолоочийн мэдээлэл шинэчлэх</ModalHeader>
          <ModalBody w={"full"} px={"6"}>
            <VStack w={"full"} spacing={2}>
              {/* -------------- Овог ---------------- */}
              <CustomInput
                title={"Овог"}
                value={lastName}
                onChange={setLastName}
                required={true}
              />
              {/* -------------- Нэр ---------------- */}
              <CustomInput
                title={"Нэр"}
                value={firstName}
                onChange={setFirstName}
                required={true}
              />
              {/* -------------- Регистрийн дугаар ---------------- */}
              <CustomInput
                title={"Регистрийн дугаар"}
                value={registerNumber}
                onChange={setRegisterNumber}
                required={true}
              />
              {/* -------------- Утас ---------------- */}
              <CustomInput
                title={"Утас"}
                value={phoneNo}
                onChange={setPhoneNo}
                type={"number"}
                required={true}
              />
              {/* -------------- Нууц үг ---------------- */}
              {editPass ? (
                <HStack w={"full"}>
                  <PasswordInput
                    title={"Нууц үг"}
                    value={password}
                    onChange={setPassword}
                    required={true}
                  />
                  <IconButton
                    isLoading={isDisable}
                    variant="solid"
                    alignSelf={"flex-end"}
                    colorScheme="teal"
                    aria-label="Done"
                    fontSize="15"
                    icon={<Icon as={IoMdCheckmark} />}
                    onClick={() => passwordHandler()}
                    isDisabled={password && !isDisable ? false : true}
                    _focusVisible={{
                      outline: "none",
                    }}
                  />
                  <IconButton
                    variant="solid"
                    alignSelf={"flex-end"}
                    colorScheme="gray"
                    aria-label="Close"
                    fontSize="15"
                    icon={<Icon as={IoMdClose} />}
                    onClick={() => {
                      setEditPass(false);
                      setPassword("");
                    }}
                    _focusVisible={{
                      outline: "none",
                    }}
                  />
                </HStack>
              ) : (
                <Center
                  transition={"ease-in-out .3s"}
                  w={"full"}
                  bg={"#ddd"}
                  h={"10"}
                  rounded={"md"}
                  cursor={"pointer"}
                  _hover={{
                    bg: "#eee",
                  }}
                  onClick={() => setEditPass(true)}
                >
                  <Text fontSize={14} color={"#000"} fontWeight={"normal"}>
                    Нууц үг солих
                  </Text>
                </Center>
              )}
              {/* -------------- Машины марк: ---------------- */}
              <CustomInput
                title={"Машины марк"}
                value={carModel}
                onChange={setCarModel}
                required={true}
              />
              {/* -------------- Машины номер ---------------- */}
              <CustomInput
                title={"Машины номер"}
                value={carPlateNumber}
                onChange={setCarPlateNumber}
                required={true}
              />
              {/* -------------- Гэрийн хаяг ---------------- */}
              <CustomTextArea
                title={"Гэрийн хаяг"}
                value={address}
                onChange={setAddress}
                required={true}
                onKeyDown={(e) => {
                  if (
                    lastName &&
                    firstName &&
                    phoneNo &&
                    address &&
                    registerNumber &&
                    password &&
                    carModel &&
                    carPlateNumber
                  ) {
                    if (e.key === "Enter") {
                      submitHandler();
                    }
                  }
                }}
              />
            </VStack>
          </ModalBody>
          <ModalFooter>
            <Button
              colorScheme="gray"
              w={"full"}
              h={"9"}
              rounded={"md"}
              fontSize={14}
              fontWeight={"medium"}
              mr={3}
              px={"8"}
              _focusVisible={{
                outline: "none",
              }}
              onClick={() => {
                onClose();
                clearData();
              }}
            >
              Болих
            </Button>
            <Button
              w={"full"}
              h={"9"}
              bg={"#1CAE81"}
              color={"#fff"}
              rounded={"md"}
              fontSize={14}
              fontWeight={"medium"}
              px={"8"}
              _focusVisible={{
                outline: "none",
              }}
              _hover={{
                bg: "#29C192",
              }}
              onClick={submitHandler}
              isDisabled={
                lastName &&
                firstName &&
                phoneNo &&
                address &&
                registerNumber &&
                carModel &&
                carPlateNumber &&
                !isDisable
                  ? false
                  : true
              }
              isLoading={isDisable}
              loadingText={"Уншиж байна..."}
            >
              Хадгалах
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </VStack>
  );
};

export default ListTable;
